import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "@/contexts/LanguageContext";
import { photoFileUrl } from "@/lib/api";

const FALLBACKS = [
  "https://images.unsplash.com/photo-1537181534458-45dcee76ae90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtb3NxdWUlMjBhcmNoaXRlY3R1cmUlMjBleHRlcmlvcnxlbnwwfHx8fDE3ODA4MTg2Mzd8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/37171409/pexels-photo-37171409.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1577561426384-62154a1e9457?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxtdXNsaW0lMjBwZW9wbGUlMjBwcmF5aW5nJTIwYXQlMjBtb3NxdWV8ZW58MHx8fHwxNzgwODE4NjM3fDA&ixlib=rb-4.1.0&q=85",
];

export default function PhotoGallery({ photos = [] }) {
  const { t, lang } = useLang();
  const fontH = lang === "ta" ? "font-serif-ta" : "font-serif-en";
  const usingFallback = photos.length === 0;
  const items = usingFallback
    ? FALLBACKS.map((src, i) => ({ id: `fb-${i}`, src, caption: "" }))
    : photos.map((p) => ({
        id: p.id,
        src: photoFileUrl(p.id),
        caption: lang === "ta" ? (p.caption_ta || p.caption_en) : (p.caption_en || p.caption_ta),
      }));

  return (
    <section id="gallery" data-testid="gallery-section" className="bg-white py-20 md:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-amber-700">معرض · Album</span>
            <h2 data-testid="gallery-heading" className={`${fontH} text-4xl md:text-5xl text-emerald-950 mt-2`}>
              {t("gallery_heading")}
            </h2>
            <p className={`mt-2 text-stone-500 ${lang === "ta" ? "font-sans-ta" : ""}`}>{t("gallery_sub")}</p>
          </div>
          <div className="text-xs text-stone-400">Hover to pause · Auto-scrolling</div>
        </div>
      </div>

      <Marquee gradient={false} speed={45} pauseOnHover>
        {items.concat(items).map((p, idx) => (
          <div key={`${p.id}-${idx}`} data-testid={`gallery-item-${idx}`} className="mx-3 group relative">
            <div className="w-[280px] sm:w-[340px] md:w-[420px] h-[260px] sm:h-[300px] md:h-[340px] overflow-hidden rounded-2xl bg-stone-100 border border-stone-200">
              <img
                src={p.src}
                alt={p.caption || "Mosque photo"}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
            </div>
            {p.caption && (
              <div className="absolute inset-x-3 bottom-3 px-4 py-2 bg-black/55 backdrop-blur text-white text-sm rounded-lg">
                {p.caption}
              </div>
            )}
          </div>
        ))}
      </Marquee>
    </section>
  );
}
